Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var coreComponentsMq = require('../../mq');
var title_index = require('../title/index.js');
var titleMobile_component = require('../title-mobile/component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

var TitleResponsive = React.forwardRef(function (_a, ref) {
    var defaultMatchMediaValue = _a.defaultMatchMediaValue, _b = _a.breakpoint, breakpoint = _b === void 0 ? 1024 : _b, restProps = tslib.__rest(_a, ["defaultMatchMediaValue", "breakpoint"]);
    var query = "(min-width: ".concat(breakpoint, "px)");
    var isDesktop = coreComponentsMq.useMatchMedia(query, defaultMatchMediaValue)[0];
    var Component = isDesktop ? title_index.Title : titleMobile_component.TitleMobile;
    return React__default.default.createElement(Component, tslib.__assign({}, restProps, { ref: ref }));
});

exports.TitleResponsive = TitleResponsive;
